module.exports = __webpack_public_path__ + "img/hand.e9fbb53d.png";